import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import { MapComponent } from './map.component';
import { InfoWindowComponent } from './info-window/info-window.component';
import { ShapeInfoWindowComponent } from './shape-info-window/shape-info-window.component';
import { AnnotationWindowComponent } from './annotation-window/annotation-window.component';
import { LayersLegendComponent } from './layers-legend/layers-legend.component';
import { LayerLegendDataComponent } from './layer-legend-data/layer-legend-data.component';
import { LayersLegendItemComponent } from './layers-legend-item/layers-legend-item.component';
import { DriveDirectionWindowComponent } from './drive-direction-window/drive-direction-window.component';
import { MapLegendComponent } from './map-legend/map-legend.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { provideHttpClient, withJsonpSupport } from '@angular/common/http';

@NgModule({ declarations: [
        MapComponent,
        InfoWindowComponent,
        ShapeInfoWindowComponent,
        AnnotationWindowComponent,
        LayersLegendComponent,
        MapLegendComponent,
        LayersLegendItemComponent,
        LayerLegendDataComponent,
        DriveDirectionWindowComponent
    ],
    exports: [
        MapComponent,
    ], imports: [CommonModule,
        SharedModule,
        GoogleMapsModule], providers: [provideHttpClient(withJsonpSupport())] })
export class MapModule {
}
